export const environment = {
  production: false,
  APIURL: 'https://apis.eaaa.in/swiftapi',
  DOC_URL: 'https://localhost:44349/uploads',
  MASTERAPIURL: 'https://apis.eaaa.in',
  MASTERCORE: 'https://localhost:44343',
  // LINUX: 'https://swift.eaaa.in/prod',
  LINUX: 'https://swift.eaaa.in',
  DOC_DOWNLOAD: 'https://apis.eaaa.in/drawdown',
  RT_LOGIN: 'https://swift.eaaa.in',
  DIGIO_URL: 'https://app.digio.in/#/gateway/login/',
  REASSIGNMENT_FOLDER: 'SWIFTLIVE/rmcxoreassignment'
  // MASTERAPIURL:'https://uatapis.edelweissalternatives.com/api',
};